module.exports = __webpack_public_path__ + "img/jbt1011_yc0_90s_2_imb35_1.prt.92062ee9.jpg";